export const INITIAL_RECOMMENDATION_LIST_SUCCESS = 'INITIAL_RECOMMENDATION_LIST_SUCCESS';
export const CREATE_INITIAL_RECOMMENDATION_SUCCESS = 'CREATE_INITIAL_RECOMMENDATION_SUCCESS';
export const EDIT_INITIAL_RECOMMENDATION_SUCCESS = 'EDIT_INITIAL_RECOMMENDATION_SUCCESS';
export const DELETE_INITIAL_RECOMMENDATION_SUCCESS = 'DELETE_INITIAL_RECOMMENDATION_SUCCESS';
